import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import { company } from '~/company/Company';
import { MODAL_EDIT_ADDRESS_PARAM, useModal } from '~/hooks/useModal';
import { useMounted } from '~/hooks/useMounted';
import { checkoutStore, orderStore, userStore } from '~/stores';
import { getAddressModalParams } from '~/utils/addressModal';

import { HeaderAddress } from '../HeaderAddress';
import { HeaderExpress } from '../HeaderExpress';
import styles from './HeaderAddressWrapper.module.scss';

const EXPRESS_TOGGLE_INTERVAL_MS = 4000;

interface HeaderAddressWrapperProps {
  className?: string;
  shortTitle?: boolean;
}

const HeaderAddressWrapper = ({
  className,
  shortTitle,
}: HeaderAddressWrapperProps) => {
  const { openModal } = useModal();

  const mounted = useMounted();
  const [isExpressMode, setIsExpressMode] = useState(false);
  const isExpressAvailable =
    mounted &&
    orderStore.isExpressAvailableNow &&
    company.showHeaderExpressBanner;

  useEffect(() => {
    if (!isExpressAvailable) {
      setIsExpressMode(false);
      return;
    }

    setIsExpressMode(true);
    const interval = setInterval(() => {
      setIsExpressMode((prev) => !prev);
    }, EXPRESS_TOGGLE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isExpressAvailable]);

  const handleAddressClick = () => {
    const isPickupWithoutSavedAddress =
      company.showDeliveryMethodSwitcher &&
      checkoutStore.isPickupSelected &&
      !userStore.addressList.some((address) => address.usage === 'pickup');

    if (isPickupWithoutSavedAddress) {
      const [targetModal, source, params] = getAddressModalParams(
        'MobileHeaderAddress',
        undefined,
        'pickup',
      );
      openModal(targetModal, source, params);
      return;
    }

    const [targetModal, source, params] = getAddressModalParams(
      'MobileHeaderAddress',
      {
        [MODAL_EDIT_ADDRESS_PARAM]: userStore?.deliveryAddress?.addressId || '',
      },
    );

    openModal(targetModal, source, params);
  };

  const showExpress = isExpressAvailable && isExpressMode;

  return (
    <div className={classes([styles.wrapper, className])}>
      <HeaderAddress
        className={classes([styles.card, !showExpress && styles.visible])}
        shortTitle={shortTitle}
        onClick={handleAddressClick}
      />
      {isExpressAvailable && (
        <HeaderExpress
          className={classes([styles.card, showExpress && styles.visible])}
          onClick={handleAddressClick}
        />
      )}
    </div>
  );
};

export default observer(HeaderAddressWrapper);
